import React, { useRef } from 'react';
import './SettingsInformation.scss';

export default function SettingsInformation() {
  const fileInputRef = useRef();

  return (
    <div className="settings-info-container">
      <div className="settings-info-photo-row  ">
  <div className="settings-info-photo-block">
    <img className="settings-info-photo" src="https://randomuser.me/api/portraits/men/32.jpg" alt="profile" />
    <div className="settings-info-photo-label">
      Your photo<br />
      <span>This will be displayed on your profile.</span>
    </div>
  </div>

  <div className="settings-info-photo-actions">
    <button type="button" className="update" onClick={() => fileInputRef.current.click()}>Update</button>
    <button type="button" className="delete">Delete</button>
    <input type="file" ref={fileInputRef} style={{ display: 'none' }} />
  </div>
</div>
      <form className="settings-info-card">



        <div className="settings-info-fields">
          <div className="settings-info-row">
        <div className="settings-info-group vertical mb-4">
  <label>Full name</label>
  <div className="settings-info-names">
    <input type="text" placeholder="First name" />
    <input type="text" placeholder="Last name" />
  </div>
</div>

          </div>
          <div className="settings-info-row">
            <div className="settings-info-group horizontal">
              <label>Email</label>
              <input type="email" placeholder="Email" />
            </div>
            <div className="settings-info-group horizontal mb-4">
              <label>Phone</label>
              <input type="text" placeholder="Phone" />
            </div>
          </div>
          <div className="settings-info-row">
            <div className="settings-info-group horizontal">
              <label>Location</label>
              <select>
                <option>Select Country</option>
                <option>Egypt</option>
                <option>Saudi Arabia</option>
                <option>UAE</option>
              </select>
            </div>
            <div className="settings-info-group horizontal">
              <label>City</label>
              <input type="text" placeholder="City" />
            </div>
            <div className="settings-info-group horizontal  mb-4">
              <label  >Street</label>
              <input type="text" placeholder="Street" />
            </div>
          </div>
          <div className="settings-info-row">
            <div className="settings-info-group horizontal">
              <label>Address line</label>
              <input type="text" placeholder="Placeholder" />
            </div>
            <div className="settings-info-group horizontal">
              <label>Qualification</label>
              <input type="text" placeholder="Placeholder" />
            </div>
            <div className="settings-info-group horizontal">
              <label>Current adjective</label>
              <input type="text" placeholder="Placeholder" />
            </div>
          </div>
        </div>
       
      </form>

       <div className="settings-info-actions">
          <button type="button" className="cancel">CANCEL</button>
          <button type="submit" className="confirm">CONFIRM</button>
        </div>
    </div>
  );
}
